import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const FooterLinks = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 10,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        px: 4,
        zIndex: 1000,
        '@media (max-width: 600px)': {
          position: 'static',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: 2,
          backgroundColor: 'background.default',
          padding: 1,
          width: '100%',
        },
      }}
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Typography variant="caption">
          <Link href="mailto:support@calmind.ai" color="text.secondary" underline="hover">
            Support
          </Link>
        </Typography>
        <Typography variant="caption">
          <Link href="https://forms.gle/sHMwSbCTEYe9Jh3S7" target="_blank" rel="noopener noreferrer" color="text.secondary" underline="hover">
            Feedback
          </Link>
        </Typography>
        <Typography variant="caption">
          <Link href="https://go.online-therapy.com/aff_c?offer_id=2&aff_id=5850" target="_blank" rel="noopener noreferrer" color="text.secondary" underline="hover">
            Get Professional Help
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default FooterLinks;
